import { useGenerateCampaignTargetAudienceMutation } from "../api";
import { CampaignSavedData } from "../types/apiTypes";
import { toast } from "react-toastify";
import { CustomToast } from "../components/ui/CustomToast";
import { getErrorMessage } from "../utils/getErrorMessage";

export const useGenerateJobTitles = (initData: CampaignSavedData) => {
  const target_industries = (initData.target_industries || []).map(
    ({ name }) => name,
  );

  const target_revenue = initData.target_revenue || [];

  const target_regions: string[] = [];
  const countries: string[] = [];

  (initData.target_regions || []).forEach((region) => {
    target_regions.push(region.name);
    countries.push(...region.countries.map(({ name }) => name));
  });

  const target_account_size =
    initData.target_account_sizes?.map(({ min_max }) => min_max) || [];

  const [generateTargetAudience, { isLoading }] =
    useGenerateCampaignTargetAudienceMutation();

  const generateJobTitles = async () => {
    try {
      const { data } = await generateTargetAudience({
        company_name: initData.company_name,
        product_name: initData.product_name,
        product_abstract: initData.product_abstract,
        product_use_case: initData.product_use_case || "",
        target_industries,
        target_regions,
        countries,
        target_account_size,
        target_revenue: target_revenue.map(({ value }) => value),
      });

      return (data?.target_audience || []).map(({ name, target_titles }) => ({
        name,
        isAdded: false,
        target_titles: target_titles.map((title) => ({
          name: title,
          isAdded: false,
          id: `${name};${title}`,
          is_critical: true,
        })),
        ignored_titles: [],
      }));
    } catch (error) {
      toast.error(
        <CustomToast
          type="error"
          text={
            //@ts-ignore
            getErrorMessage(error).globalError ||
            "Something went wrong during processing. Please try again"
          }
          title="Failed to generate job titles"
        />,
      );

      return [];
    }
  };

  return { generateJobTitles, isLoadingTitles: isLoading };
};
